import { Button } from '@/components/ui/button';
import React from 'react';
import { useHistory } from 'react-router-dom';
import headerLogo from '../../images/logo_cybersign--black.svg';
import ListItemComponent from './components/ListItemComponent';
import styles from './register-start.module.css';

interface RegisterProps {
	nextStep: () => void;
}

const RegisterStart: React.FC<RegisterProps> = ({ nextStep }) => {
	const history = useHistory();

	return (
		<div className={styles['register-start']}>
			<div className={styles.body}>
				<div className="text-center">
					<h5>Bienvenido a</h5>
					<div className="cyber-spacer"></div>
					<img className="center" src={headerLogo} alt="" />
					<div className="cyber-spacer small"></div>
					<h5>El registro toma 5 minutos y consiste en</h5>
				</div>
				<div className="cyber-spacer medium"></div>
				<div className="cyber-register-list">
					<ListItemComponent
						itemNumber={1}
						itemHeader={'Información personal'}
						itemMessage={
							<p>Llena un formulario con tus datos personales.</p>
						}
					/>

					<ListItemComponent
						itemNumber={2}
						itemHeader={'Comprueba tu identidad'}
						itemMessage={
							<p>
								Para comprobar tu identidad, necesitaremos tu{' '}
								<b>celular</b> para grabar unas selfies y
								compartir fotos de tu <b>DPI</b>.
							</p>
						}
					/>

					<ListItemComponent
						itemNumber={3}
						itemHeader={'Configuración de autenticación en 2 pasos'}
						itemMessage={
							<p>
								Descarga la aplicación Google Authenticator o
								Microsoft Authenticator en tu celular Una vez la
								tengas instalada, haz click en continuar.
							</p>
						}
					/>

					<ListItemComponent
						itemNumber={4}
						itemHeader={'Define tu primera firma'}
						itemMessage={
							<p>Has el manuscrito de tu firma personal.</p>
						}
					/>
				</div>
				<div
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<Button
						variant="secondary"
						onClick={() => history.push('/dashboard')}
					>
						Regresar
					</Button>
					<Button variant="default" onClick={nextStep}>
						Comencemos
					</Button>
				</div>
			</div>
		</div>
	);
};

export default RegisterStart;
